import { BoxProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { Surface } from './Surface';

interface DataTableSurfaceProps extends BoxProps {
  children: ReactNode;
}

export function DataTableSurface({ children, ...props }: DataTableSurfaceProps) {
  return (
    <Surface variant="table" {...props}>
      {children}
    </Surface>
  );
}
